import styled from 'styled-components'
import { GridMain } from '@components/Grid/index.style'

export const PageFooterMain = styled.section`
  color: ${props => props.color};
  background-color: ${props => props.background};

  ${GridMain} {
    align-items: end;
  }
`

export const PageFooterWrapper = styled.div`
  position: relative;
`

export const CMSButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`